import { useBreakpoint, Breakpoints } from '@nextgen-web-framework/all';
import { FrameRectangle } from '@commerce-cart-webcomponents/ui';
import styles from './MyListsPageLoader.module.scss';
import { LoaderColums, LoaderRows } from './types/enums';

export const MyListsPageLoader = () => {
  const viewPort = useBreakpoint();

  const getRows = () => {
    if ([Breakpoints.XS, Breakpoints.SM, Breakpoints.MD].includes(viewPort as Breakpoints)) {
      return LoaderRows.SM;
    }

    return LoaderRows.LG;
  };

  const getColums = () => {
    if ([Breakpoints.XS, Breakpoints.SM].includes(viewPort as Breakpoints)) {
      return LoaderColums.SM;
    }

    return LoaderColums.LG;
  };

  return (
    <div className={styles['my-list-page-loader-wrapper']}>
      {[...Array(getColums()).keys()].map((key) => (
        <div key={key} className={styles['my-list-page-loader']}>
          <FrameRectangle className={styles['my-list-page-loader-rectangle']} />
          <div className={styles['my-list-page-loader-section-middle']}>
            {[...Array(getRows()).keys()].map((key) => (
              <FrameRectangle key={key} className={styles['my-list-page-loader-rectangle-middle']} />
            ))}
          </div>
          <FrameRectangle className={styles['my-list-page-loader-rectangle']} />
        </div>
      ))}
    </div>
  );
};
